import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { RequestParams, ResponseCatalog } from 'Models'
import { NotificationStatsModel, NotificationListModel, BikSuggestModel } from 'Modules'
import { Id } from 'Src/types/aliases'
import { sanitizeHtml } from 'Helpers'

async function getAll(requestParams: RequestParams) {
	const res = await axiosDS().get<ResponseCatalog<NotificationListModel>>(
		urls.modules.notifications.index,
		{ params: requestParams }
	)
	res.data.entries = (res.data.entries ?? []).map((entity) => {
		entity.message = sanitizeHtml(entity.message)
		return entity
	})
	return res.data
}

async function deleteOne(id: Id) {
	const res = await axiosDS().delete(`${urls.modules.notifications.index}/${id}`)
	return res.data
}

async function readOne(id: Id) {
	const res = await axiosDS().patch(`${urls.modules.notifications.index}/${id}/read`)
	return res.data
}

async function getStats() {
	const res = await axiosDS().get<NotificationStatsModel>(
		`${urls.modules.notifications.index}/stats`
	)
	return res.data
}

async function readAll(group: string) {
	const res = await axiosDS().patch(`${urls.modules.notifications.index}/read_all?group=${group}`)
	return res.data
}

async function deleteAll(group: string) {
	const res = await axiosDS().delete(
		`${urls.modules.notifications.index}/destroy_all?group=${group}`
	)
	return res.data
}

async function getBankApi(query: string) {
	const res = await axiosDS().get<BikSuggestModel[]>(`${urls.common.bik}?query=${query}`)
	return res.data
}

export const notificationListApi = {
	getAll,
	deleteOne,
	readOne,
	deleteAll,
	readAll,
	getStats,
	getBankApi,
}
